import Marquee3k from 'marquee3000';

export default function _ticker() {
    Marquee3k.init();
}

_ticker();
